<template>
  <el-dialog title="Add collateral" :visible.sync="isOpen" width="10.56rem" append-to-body :close-on-click-modal="false"
    destroy-on-close>
    <div style="padding:0 0.22rem;">
      <div class="detail-item top-title" style="margin-top: 0;">
        <i class="el-icon-warning" />
        You need to add collateral to to raise your collateralization ratio above the early warning threshold, or your
        pledged UNIT will be liquidated.
      </div>
      <div class="detail-item spaceLeft">
        <span class="detail-item-label">Outstanding:</span>
        <div>
          <div>
            <span class="bb"><big-number :number="pageData.loanAmount" /></span><span class="unit">TCash</span>
          </div>
          <span class="price-value">Price:</span>
          <span class="price-value">${{ TCASHPrice }}</span>
          <span class="price-value">Value:</span>
          <span class="price-value">${{ calculateTotalValue }}</span>
        </div>
      </div>

      <div class="detail-item spaceLeft">
        <span class="detail-item-label">Collateral:</span>
        <span><big-number :number="pageData.unitAmount" />
         <span class="unit"> UNIT</span>
        </span>
      </div>
      <div class="detail-item spaceLeft">
        <span class="detail-item-label">Add collateral :</span>
        <div class="balance-box">
          <el-input v-model="inputVal" @input="handleInput"><template slot="append">UNIT</template></el-input>
          <!-- <span class="unit">Balance : <big-number :number="balanceShow" /></span> -->
          <div style="display: flex;justify-content: flex-start;margin-top: 0.05rem;">
            <div class="unit">Price : ${{ unitPrice }}</div>
            <div class="unit">Value : ${{ calculateTotalValueUnit }}</div>
          </div>
        </div>
        <el-button type="text" style="margin-left:0.1rem;" @click="inputMax">Max</el-button>
      </div>
      <div class="detail-item spaceBetween">
        <div>
          <span class="detail-item-label">Collateral Ratio:</span>
          <span class="rate">{{ calculateCollateralRatio() }}%</span>
        </div>
        <div>
          <span class="detail-item-label">Early warning threshold:</span>
          <span class="c-unit">

            <span class="rate warning-threshold">{{ warningThresholdText }}</span>
            <!-- <div class="threshold-desc">
            <span class="price-value">Min collateral value: ${{ minCollateralValue }}</span>
          </div> -->

          </span>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">Cancel</el-button>
      <loading-btn type="primary" :label="buttonLabel" :disabled="isSubmitDisabled" @clickHandle="debounceSubmit" />
    </span>
  </el-dialog>
</template>

<script>
import { deepClone, isIntNum } from "@/utils/index.js";
import { toBigNum, toBigItem, fixed } from "@/utils/bigNumberTran.js";
import {
  toSmallNum,
} from "@/utils/bigNumberTran.js";
import { loanDetail } from "@/api/ustn/loan.js";

export default {
  data() {
    return {
      type: "1",
      isOpen: false,
      pageData: {},
      inputVal: undefined,
      balance: 0,
      unitPrice: 0,
      currentRecord: {},
      TCASHPrice: 0,
      warningThreshold: 0,
      isSubmitting: false,
      debounceTimer: null,
      btnInstance: null
    };
  },
  computed: {
    collateral() {
      let x = new this.BigNumber(this.pageData.unitAmount || 0);
      let y = toBigItem(this.inputVal || 0)
      if (!isIntNum(+this.inputVal)) {
        y = 0;
      }
      return x.plus(y);
    },
    balanceShow() {
      let a = new this.BigNumber(this.balance);
      let b = toBigItem(this.inputVal || 0);
      if (!isIntNum(+this.inputVal)) {
        b = 0;
      }
      return a.minus(b);
    },
    pledgeRateShow() {
      if (!this.inputVal && +this.pageData.pledgeRate !== 0) {
        return this.pageData.pledgeRate / 100;
      }
      let a = new this.BigNumber(this.collateral).multipliedBy(this.unitPrice);
      let b = new this.BigNumber(this.pageData.totalDebt).multipliedBy(this.ustnPrice);
      let res = a.dividedBy(b).multipliedBy(100).toNumber();
      return Math.round(res * 100) / 100;
    },
    calculateTotalValue() {
      if (!this.pageData.loanAmount || !this.TCASHPrice) {
        return "0.00";
      }
      const loanAmount = new this.BigNumber(this.pageData.loanAmount || 0);
      const tcashPrice = new this.BigNumber(this.TCASHPrice || 0);
      const result = loanAmount.multipliedBy(tcashPrice).dividedBy(1e18).toFixed(9);
      return parseFloat(result).toString();
    },
    calculateTotalValueUnit() {
      console.log('calculateTotalValueUnit', this.inputVal, this.unitPrice);
      if (!this.inputVal || !this.unitPrice) {
        return "0.00";
      }
      const inputVal = new this.BigNumber(this.inputVal || 0);
      const unitPrice = new this.BigNumber(this.unitPrice || 0);
      const result = inputVal.multipliedBy(unitPrice).toFixed(9);
      console.log('calculateTotalValueUnit', parseFloat(result).toString());
      return parseFloat(result).toString();
    },
    warningThresholdText() {
      if (!this.warningThreshold) {
        return "0%";
      }
      // TCASHMCT是以10000为基数的百分比，需要除以10000显示
      const thresholdPercent = new this.BigNumber(this.warningThreshold).dividedBy(10000);
      return `${thresholdPercent.toFixed(2)}%`;
    },
    minCollateralValue() {
      if (!this.pageData.loanAmount || !this.TCASHPrice || !this.warningThreshold) {
        return "0.00";
      }

      // 计算借款的美元价值
      const loanAmount = new this.BigNumber(this.pageData.loanAmount || 0);
      const tcashPrice = new this.BigNumber(this.TCASHPrice || 0);
      const loanValue = loanAmount.multipliedBy(tcashPrice).dividedBy(1e18);

      // 计算预警线要求的最低抵押品价值
      const warningRate = new this.BigNumber(this.warningThreshold).dividedBy(10000);
      const minValue = loanValue.multipliedBy(warningRate);

      return minValue.toFixed(2);
    },
    isSubmitDisabled() {
      // 如果计算出的质押率小于预警线，按钮不可点击
      const currentRatio = parseFloat(this.calculateCollateralRatio());
  
      const warningThreshold = parseFloat(new this.BigNumber(this.warningThreshold).dividedBy(10000).toFixed(2));
     
      return currentRatio < warningThreshold;
    },
    buttonLabel() {
      // 如果计算出的质押率小于预警线，文案为Add More Collateral
      const currentRatio = parseFloat(this.calculateCollateralRatio());
      const warningThreshold = parseFloat(new this.BigNumber(this.warningThreshold).dividedBy(10000).toFixed(2));
      
      if (currentRatio < warningThreshold) {
        return "Add More Collateral";
      } else {
        return "Submit";
      }
    }
  },
  methods: {
    async getCurrentRecord() {
      try {
        const res = await loanDetail({
          loanId: this.pageData.loanId,
        });
        console.log('getLoanDetailres', res);

        // 更新currentRecord，使用res.result中的数据
        this.currentRecord = res.result.current;
        console.log('currentRecord', this.currentRecord);
      } catch (err) {
        console.log(err);
      }
    },
    calculateCollateralRatio() {
      // 计算当前抵押率
      if (!this.unitPrice || !this.TCASHPrice || !this.currentRecord) {
        return 0;
      }

      // 计算UNIT抵押物总价值
      let unitAmount = new this.BigNumber(this.currentRecord.unitAmount || 0);
      
      // 如果有用户输入的额外抵押品，加上这部分
      if (this.inputVal && isIntNum(+this.inputVal)) {
        const additionalUnit = toBigItem(this.inputVal || 0);
        unitAmount = unitAmount.plus(additionalUnit);
      }
      
      const unitPrice = new this.BigNumber(this.unitPrice || 0);
      const unitTotalValue = unitAmount.multipliedBy(unitPrice).dividedBy(1e18);

      // 计算TCash借款总价值
      const tcashAmount = new this.BigNumber(this.currentRecord.loanAmount || 0);
      const tcashPrice = new this.BigNumber(this.TCASHPrice || 0);
      const tcashTotalValue = tcashAmount.multipliedBy(tcashPrice).dividedBy(1e18);

      // 如果借款价值为0，则避免除以0的错误
      if (tcashTotalValue.isEqualTo(0)) {
        return 0;
      }

      // 计算抵押率并返回百分比值，保留2位小数
      return unitTotalValue.dividedBy(tcashTotalValue).multipliedBy(100).toFixed(2);
    },
    open({ type, row } = {}) {
      this.type = type;
      this.isOpen = true;
      this.pageData = deepClone(row);
      console.log('pageData', this.pageData);
      this.inputVal = undefined;
      this.init();
    },
    close() {
      this.isOpen = false;
      this.inputVal = undefined;
      this.pageData = {};
    },
    async init() {
      this.contractTCashLoan = this.$store.getters.contractMap["contractTCashLoan"].contract;
      this.contractTCashLoanAddress = this.$store.getters.contractMap["contractTCashLoan"].address;
      this.contractOracle = this.$store.getters.contractMap["contractOracle"].contract;
      this.contractOracleAddress = this.$store.getters.contractMap["contractOracle"].address;
      this.contractParameterInfo = this.$store.getters.contractMap["contractParameterInfo"].contract;

      await this.getBalance();
      await this.getUnitPrice();
      await this.getTCashPrice();
      await this.getWarningThreshold();
      console.log('unitPrice', this.unitPrice);
      console.log('TCASHPrice', this.TCASHPrice);
      console.log('warningThreshold', this.warningThreshold);
      await this.getCurrentRecord();
    },
    async getUnitPrice() {
      try {
        let Oracleres = await this.contractOracle.methods.getPriceData("UNIT").call({
          from: this.$store.getters.metaMaskObj.account
        });
        this.unitPrice = (Oracleres.price / 10000).toFixed(2);
        console.log('unitPrice', this.unitPrice);
      } catch (e) {
        console.log(e);
      }
    },
    async getTCashPrice() {
      try {
        let Oracleres = await this.contractOracle.methods.getPriceData("TCASH").call({
          from: this.$store.getters.metaMaskObj.account
        });
        this.TCASHPrice = (Oracleres.price / 10000).toFixed(2);
      } catch (e) {
        console.log(e);
      }
    },
    async getBalance() {
      try {
        this.balance = await web3.eth.getBalance(this.$store.getters.metaMaskObj.account);
      } catch (e) {
        console.log(e);
      }
    },
    async getWarningThreshold() {
      try {
        const warningThreshold = await this.contractParameterInfo.methods.getPlatformConfig("TCASHMCT").call({
          from: this.$store.getters.metaMaskObj.account
        });
        console.log('TCASHMCT预警线:', warningThreshold);
        this.warningThreshold = warningThreshold;
      } catch (error) {
        console.error('获取TCASHMCT预警线失败:', error);
        this.warningThreshold = 1200000; // 默认值120% * 10000
      }
    },
    handleInput(val) {
      if (val) {
        if (!isIntNum(+val)) {
          return;
        }
        
        if (toBigItem(val).comparedTo(this.balance) > 0) {
          this.inputVal = toSmallNum(this.balance).toString();
        }
      }
    },
    inputMax() {
      if (this.balance > 0) {
        const maxAmount = new this.BigNumber(this.balance).multipliedBy(0.95);
        this.inputVal = toSmallNum(maxAmount).toString();
      }
    },
    checkVal() {
      if (!isIntNum(+this.inputVal)) {
        this.$message.warning(`Please enter a number`);
        return false;
      }
      if (+this.inputVal <= 0 || !this.inputVal) {
        this.$message.warning("Added value cannot be less than or equal to 0");
        return false;
      }
      if (toBigItem(this.inputVal).comparedTo(this.balance) > 0) {
        this.$message.warning("Sorry, your credit is running low");
        return false;
      }
      return true;
    },
    debounceSubmit(btn) {
      this.btnInstance = btn;
      
      // 如果已经在提交中，直接返回
      if (this.isSubmitting) {
        btn.closeLoad();
        return;
      }
      
      // 清除之前的定时器
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      
      // 设置防抖延迟
      this.isSubmitting = true;
      this.debounceTimer = setTimeout(() => {
        this.save();
      }, 500); // 500ms防抖时间
    },
    save() {
      if (!this.btnInstance) return;
      
      if (!this.checkVal()) {
        this.btnInstance.closeLoad();
        this.isSubmitting = false;
        return;
      }

      const tx_builder = this.contractTCashLoan.methods["collateralTopUp"](this.pageData.loanId);
      const encoded_tx = tx_builder.encodeABI();

      web3.eth
        .sendTransaction({
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: this.contractTCashLoanAddress,
          value: toBigNum(this.inputVal),
          data: encoded_tx
        })
        .then(res => {
          this.$emit("refresh");
          this.close();
          this.$message.success("Add collateral successfully! The alert status has been lifted.");
        })
        .catch(error => {
          this.$message.error("operation failed");
          console.error(error);
        })
        .finally(() => {
          if (this.btnInstance) {
            this.btnInstance.closeLoad();
            this.btnInstance = null;
          }
          // 重置提交状态
          this.isSubmitting = false;
        });
    }
  },
  created() { }
};
</script>
<style scoped lang="scss">
.unit {
  font-size: 0.16rem;
  font-weight: 400;
  color: #929dad;
  margin-left: 0.04rem;
  margin-bottom: -0.1rem;
}

.big-num {
  font-size: 0.28rem;
  font-weight: 500;
  color: #1F1F1F;
}

.detail-item {
  margin-bottom: 0.35rem;
}

.balance-box {
  position: relative;
  flex: 1 0 0;

  &>span {
    position: absolute;
    right: 0.02rem;
    top: -0.3rem;
  }

  ::v-deep  .el-input-group {
    border-radius: 4px;
    border: 1px solid #D9DDE3;
  }

  ::v-deep  .el-input__inner {
    height: 0.48rem;
    background: transparent;
    border-color: transparent;
    // border-color:#D9DDE3;
  }

  ::v-deep  .el-input-group__append {
    background: transparent;
    border-color: transparent;
    font-size: 0.18rem;
    color: #AAAAAA;
  }
}

.top-title {
  font-size: 0.24rem;
  font-weight: 500;
  color: #1F1F1F;
  line-height: 0.36rem;
  position: relative;
  word-break: break-word;

  .el-icon-warning {
    position: absolute;
    left: -0.32rem;
    top: 0.06rem;
    color: #FAAD14;
    font-size: 0.24rem;
  }
}

>>>.el-dialog__header .el-dialog__title {
  color: #1F1F1F;
  font-weight: bold;
  font-size: .28rem;
}

.bb .big-number {
  color: #1F1F1F;
  font-size: .28rem;
  font-weight: 500;
}

.rate {
  font-weight: 500;
  font-size: .2rem;
  color: #D71718;
}

.warning-threshold {
  color: #1F1F1F;
  font-size: .22rem;
}

.threshold-desc {
  margin-top: 0.05rem;
}

.c-unit .big-number {
  color: #1F1F1F;
  font-size: .2rem;
  font-weight: 500;
}

.price-value {
  font-size: 0.16rem;
  font-weight: 400;
  color: #929DAD;
}
</style>
